import { /* googleAnalyticsApis, */ jaegerApi } from 'Api/index'
// import GA_MAP, { pathMap, UserMap, getEventByRequest } from "./GoogleAnalyticsMap/index";
import { store } from 'Store/store.index'
// import { USER_SIGN_IN_SUCCESS } from "Store/constants";
import { /* prop */ } from '@/utils/utils';

export class UserBehaviorTrackingService {
    constructor() {
      this.signInSuccessSpan = null
    //   this.onUserSignInSuccessForJaeger();
        this.initStore();
    }


    initStore() {
      return new Promise((resolve) => {
        let flag = setInterval(() => {
          if (store) {
            clearInterval(flag);
            resolve();
          }
        }, 0);
      });
    }
    // async onUserSignInSuccessForJaeger() {
    //     await this.initStore().catch((error) => {
    //       console.error(error)
    //     })
    //     const { appEventEmitter } = store.appStore;
    //     const onSendJaegerData = async () => {
    //       let apps;
    //       let extraInformation;
    //       let plan_expires_in = '';
    //       const { full_name: username } = store.userStore.userInfo;
    //       const { accountStore } = store;

    //       if (accountStore && accountStore.apps && accountStore.apps.length) {
    //         apps = accountStore.apps;
    //         plan_expires_in = apps[0].expiredDate;
    //       }

    //       extraInformation = {
    //         _group3: 'activities',
    //         username,
    //         plan_expires_in,
    //         industry: '',
    //         respresentative: '',
    //         location: '',
    //       };

    //       this.signInSuccessSpan =  await jaegerApi.sendJaegerData({ spanName: 'sign_in_out_duration', operationName: 'sign_in_out_duration', extraInformation, isReturnSpan: true });

    //       jaegerApi.sendJaegerData({ spanName: 'sign_in_success', operationName: 'sign_in_success', extraInformation})
    //     };

    //     appEventEmitter.removeListener(USER_SIGN_IN_SUCCESS, onSendJaegerData)
    //     appEventEmitter.on(USER_SIGN_IN_SUCCESS, onSendJaegerData)
    // }
    doSendJaegerData(eventKey, extraInformation) {
        let jaegerCategory = 'event';
        jaegerApi.sendJaegerData({  extraInformation, category: jaegerCategory,eventKey })
    }

    doSendGAEvent({eventKey,extraInformation}) {
        
        // googleAnalyticsApis.jRsRgaSend(label, category, action, value)

        this.doSendJaegerData(eventKey,extraInformation)
    }
    // doSendGAEventByRequest(type, status) {
    //     let value = getEventByRequest(status, type);
    //     if (!value) {
    //         if(process.env.NODE_ENV == 'development')console.warn(`TCL: doSendGAEventByRequest -> type: ${type}, status: ${status}, can not found label`)
    //         return
    //     }
        
    //     const { category, action } = value;
    //     googleAnalyticsApis.jRsRgaSend('Event', category, action)
    //     store.appStore.doSaveAction(action);
    // }

    // doSendGAEventByUser({ eventKey, label, param }) {
    //     store.appStore.doSaveAction(eventKey);
        
    //     // let extraInformation
    //     let pathName = prop(location, 'pathname');
    //     let eventLabel = label
    //     let pre = pathMap[pathName];
    //     if (!pre) {
    //         if(process.env.NODE_ENV == 'development')console.warn(`TCL: doSendGAEventByUser -> eventKey: ${eventKey}, label: ${label}, can not found page map`)
    //         return;
    //     }
    //     let eventValue;
    //     do {
    //         let subMap = UserMap[label];
    //         if (!subMap) break;
    //         eventValue = subMap[eventKey];
    //     } while (false)
    //     if (!eventValue) {
    //         if(process.env.NODE_ENV == 'development')console.warn(`TCL: doSendGAEventByUser -> eventKey: ${eventKey}, label: ${label}, can not found label`)
    //         return
    //     }
    //     label = pre + label;
    //     const { category, action } = eventValue;
    //     let fullAction = param ? action + '_with_' + param : action;

        
    //     googleAnalyticsApis.jRsRgaSend(label, category, fullAction)

    //     this.doSendJaegerData(category, eventLabel, action)
    // }

    // doSendGAEventByUserEvent(eventKey, addedValue, callback) {
    //     store.appStore.doSaveAction(eventKey);
    //     let subMap = GA_MAP['user_event']
    //     let value = subMap[eventKey];
    //     if (!value) {
    //         if(process.env.NODE_ENV == 'development')console.warn(`TCL: doSendGAEventByUserEvent -> eventKey: ${eventKey}, label: user_event, can not found label`)
    //         return
    //     }
    //     const { category, action } = value;
    //     let curAction = action;
    //     if (addedValue) {
    //         curAction = action + addedValue;
    //     }
        
    //     googleAnalyticsApis.jRsRgaSend('Event', category, curAction).then(() => {
    //         callback && callback()
    //     })
    // }
}